export { youtubeVideoId } from '../server/lot07/youtube.mjs';
export type TutorialStep = { imageDataUrl?: string; youtubeUrl?: string; caption: string };
export async function tutorialImage(file: globalThis.Blob): Promise<string> {
  if (
    !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) ||
    file.size < 1 ||
    file.size > 12 * 1024 * 1024
  )
    throw new Error('Choisissez une image JPEG, PNG ou WebP de 12 Mo maximum.');
  const data = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result));
    reader.onerror = () => reject(new Error('Image illisible.'));
    reader.readAsDataURL(file);
  });
  if (file.size <= 256 * 1024) return data;
  const image = await new Promise<HTMLImageElement>((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve(img);
    img.onerror = () => reject(new Error('Image illisible.'));
    img.src = data;
  });
  const canvas = document.createElement('canvas');
  const scale = Math.min(1, 1200 / Math.max(image.width, image.height));
  canvas.width = Math.max(1, Math.round(image.width * scale));
  canvas.height = Math.max(1, Math.round(image.height * scale));
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Compression indisponible. Choisissez une image plus petite.');
  context.fillStyle = 'white';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.drawImage(image, 0, 0, canvas.width, canvas.height);
  for (const quality of [0.8, 0.65, 0.5, 0.35]) {
    const result = canvas.toDataURL('image/jpeg', quality);
    if (result.length < 349500) return result;
  }
  throw new Error('Image trop détaillée. Recadrez-la ou choisissez une image plus petite.');
}
